  export default {
  GET_NODE_ACTIONS: 'getNodeActions',
  UPLOAD_FILE: 'uploadFile',
  UPLOAD_FILE_PARALLEL: 'uploadFileParallel',
  CREATE_FOLDER: 'createFolder',
  CUSTOM_ACTION: 'customAction',
  DOWNLOAD_FILE: 'downloadFile',
  RENAME: 'rename',
  REMOVE: 'remove',
  SYNC: 'syncFolder',
  MOVE: 'move',
  MOVE_ENTRIES: 'moveEntries',
  COPY: 'copy',
  COPY_ENTRIES: 'copyEntries',
  REMOVE_ENTRIES: 'removeEntries',
  CREATE_GDOC: 'createGdoc',
  EDIT_GDOC: 'editGdoc',
  FINISH_EDIT_GDOC: 'finishEditGdoc',
  CONVERT_TO_GDOC: 'convertToGDoc',
  GENERATE_DOWNLOAD_LINK: 'generateDownloadLink',
  SHARE_MULTI_NODE_DOWNLOAD: 'shareMultiNodeDownload',
  SET_CUSTOM_ICON: 'setCustomIcon',
}
